<template>
  <div class="container">
    <h1 class="text-center main-title" v-html="$t('title.about')">
      关于
      <em>我们</em>
      <span>About</span>
    </h1>

    <ul class="clearfix aside text-center">
      <li
        v-for="(item,index) in aboutList"
        class="aside-title"
        :key="index"
        v-on:click="getAboutId(item.url)"
      >
        <router-link :to="'/about/'+item.id" exact>{{item.subname}}</router-link>
      </li>
    </ul>

    <div v-html="aboutInfo.body" class="main-content">
      <!-- {{aboutInfo.content}}  -->
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  metaInfo() {
    return {
      title: this.pageName
    }; // set a title
  },
  data() {
    return {
      //aboutList: aboutdata,
      aboutInfo: {},
    };
  },

  watch: {
    $route() {
      //console.log(this.$route.params.aboutId);
      //this.getDate();
      var id = this.$route.params.aboutId;
      if (id == "honour") {
        id = "honor";
      } else {
        id = "about";
      }
      this.getAboutId(id);
    }
  },

  computed: {
    aboutList() {
      return this.$t("nav_foot[0].subnavigation");
      // return this.aboutInfo.title
    },
    pageName(){
      return this.$t("nav[1].name");
    }
  },
  methods: {
    getAboutId(url) {
      var id = this.$route.params.aboutId;
      //console.log(url);
      sessionStorage.setItem("aboutId", url);
      this.$http
        .get("http://www.hzjingbao.cn/api/page", {
          params: {
            lang: this.$i18n.locale,
            type: url
          }
        })
        .then(res => {
          console.log(res.data);
          this.aboutInfo = res.data;
        })
        .catch(erroe => {
          console.log(error);
        });
    }
  },
  mounted() {
    // this.$http
    //   .get("http://www.hzjingbao.cn/api/page", {
    //     params: {
    //       lang: this.$i18n.locale,
    //       type: "about"
    //     }
    //   })
    //   .then(res => {
    //     //console.log(res.data);
    //     this.aboutInfo = res.data;
    //     console.log(this.aboutInfo);
    //   })
    //   .catch(erroe => {
    //     console.log(error);
    //   });
  },
  created() {
    //console.log(1);
    //console.log(this.$route.params.aboutId);
    if (this.$route.params.aboutId == "honour") {
      this.$http
        .get("http://www.hzjingbao.cn/api/page", {
          params: {
            lang: this.$i18n.locale,
            type: honour
          }
        })
        .then(res => {
          //console.log(res.data);
          this.aboutInfo = res.data;
          // if(this.$i18n.locale == 'en'){

          // }
        })
        .catch(erroe => {
          console.log(error);
        });
    } else {
      this.$http
        .get("http://www.hzjingbao.cn/api/page", {
          params: {
            lang: this.$i18n.locale,
            type: "about"
          }
        })
        .then(res => {
          //console.log(res.data);
          this.aboutInfo = res.data;
          //console.log(this.aboutInfo);
        })
        .catch(erroe => {
          console.log(error);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/about.vue